<template>
<div>
  <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="100px" class="demo-ruleForm">
    <el-row>
      <el-col :span="12">
        <el-form-item label="操作人" prop="operator">
          <el-input v-if="addEditObj.isAdd" v-model="addEditForm.operator" placeholder="请输入操作人"></el-input>
          <span v-else>{{addEditForm.operator}}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="留样日期" prop="sampleday">
          <el-date-picker v-fixZoom v-if="addEditObj.isAdd" style="width: 100%" v-model="addEditForm.sampleday" :clearable="false"
                          type="date" value-format="yyyy-MM-dd" placeholder="请选择">
          </el-date-picker>
          <span v-else>{{addEditForm.sampleday}}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="供应商" prop="">
          <el-input v-if="addEditObj.isAdd" v-model="addEditForm.vendor" placeholder="请输入供应商"></el-input>
          <span v-else>{{addEditForm.vendor}}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="所属餐厅" prop="restaurantid">
          <el-select v-fixZoom v-if="addEditObj.isAdd" :disabled="!addEditObj.isAdd" v-model="addEditForm.restaurantid" filterable placeholder="请选择" :clearable="true" style="width:100%;">
            <el-option v-for="item in restaurants" :key="item.index" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <span v-else>{{getRestaurantName(addEditForm.restaurantid)}}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="编号" prop="">
      <div>
        <el-tag :key="tag" v-for="tag in dynamicTags" :closable="addEditObj.isAdd" :disable-transitions="false" @close="handleClose(tag)">
          {{tag}}
        </el-tag>
        <el-input style="width: 100px" class="input-new-tag" v-if="inputVisible" v-model="inputValue"
          ref="saveTagInput" size="small" @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm">
        </el-input>
        <el-button v-if="addEditObj.isAdd && !inputVisible" class="button-new-tag" size="small" @click="showInput"> + </el-button>
      </div>
    </el-form-item>
    <el-form-item label="备注" prop="">
      <el-input v-if="addEditObj.isAdd" type="textarea" :rows="2" v-model="addEditForm.desc" placeholder="请输入备注"></el-input>
      <span v-else>{{addEditForm.desc}}</span>
    </el-form-item>
    <el-form-item label="留样照片" prop="">
      <div>
<!--        :disabled="!addEditObj.isAdd"-->
        <el-upload v-if="addEditObj.isAdd" class="upload-img" action="#" list-type="picture-card" accept=".png,.jpg"
                   :auto-upload="false" :on-preview="handlePictureCardPreview"
                   :on-remove="handleRemove" :on-success="handleSuccess" :on-error="handleError"
                   :on-change="handleChange" :limit="5"  :file-list="dialogImageUrlArray" ref="upload">
          <i class="el-icon-plus"></i>
        </el-upload>
        <img v-else style="width: 100px;height: 100px;margin-right: 5px;cursor: pointer" v-for="(item, index) in dialogImageUrlArray" :src="item.url" :key="index" @click="handlePictureCardPreview(item)"/>
        <el-dialog :visible.sync="dialogVisible" width="800px" append-to-body>
          <div style="text-align: center">
            <img style="max-width: 100%" :src="dialogImageUrl" alt="">
          </div>
        </el-dialog>
      </div>
    </el-form-item>
  </el-form>
  <div v-if="addEditObj.isAdd" style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEdit('addEditForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {uploadimage, addfoodsample, updatefoodsample} from '../../../api/yanglaoyuan'
// import {getToken} from '../../../utils/auth'

export default {
  name: 'addEditSample',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      restaurants: [], // 餐厅
      addEditForm: {
        id: '',
        'sampleday': '',
        'operator': '',
        'desc': '',
        'pictures': '',
        'sampleno': '',
        'vendor': '',
        'restaurantid': '',
        'eid': ''
      },
      addEditRules: {
        sampleday: [
          {required: true, message: '请选择日期', trigger: 'change'}
        ],
        restaurantid: [
          {required: true, message: '请选择餐厅', trigger: 'change'}
        ],
        operator: [
          {required: true, message: '请输入操作人', trigger: 'blur'}
        ],
        vendor: [
          {required: true, message: '请输入供应商', trigger: 'blur'}
        ]
      },
      // 编号
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      // 留样照片
      dialogImageUrl: '',
      dialogImageUrlArray: [],
      hideUpload: false,
      dialogVisible: false
    }
  },
  created () {
    this.restaurants = this.addEditObj.restaurants
    if (this.addEditObj.isAdd) {
      this.addEditForm.eid = this.$store.state.user.LoginResp.entity_id
    } else {
      let row = this.clone(this.addEditObj.row)
      this.addEditForm.id = row.id
      this.addEditForm.sampleday = row.sampleday
      this.addEditForm.operator = row.operator
      this.addEditForm.desc = row.desc
      this.addEditForm.pictures = row.pictures
      this.addEditForm.sampleno = row.sampleno
      this.addEditForm.vendor = row.vendor
      this.addEditForm.restaurantid = row.restaurantid
      this.addEditForm.eid = row.eid
      this.dialogImageUrlArray = row.pictureArr

      let list = []
      let arr = row.sampleno.split(',')
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== '') {
          list.push(arr[i])
        }
      }
      this.dynamicTags = list
    }
  },
  methods: {
    getRestaurantName (id) {
      let name = id
      for (let i = 0; i < this.restaurants.length; i++) {
        if (id === this.restaurants[i].id) {
          name = this.restaurants[i].name
        }
      }
      return name
    },
    // 编号
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    // 上传图片
    handleSuccess (res, file, fileList) {
      this.$message.success('上传成功')
    },
    // eslint-disable-next-line handle-callback-err
    handleError (err, file, fileList) {
      this.$message.error('上传失败')
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove (file, fileList) {
      if (!this.addEditObj.isAdd) {
        this.$message.error('不能删除图片！')
        return
      }
      for (let i = 0; i < this.dialogImageUrlArray.length; i++) {
        if (this.dialogImageUrlArray[i].url === file.url) {
          this.dialogImageUrlArray.remove(this.dialogImageUrlArray[i])
        }
      }
      // console.log(99, this.dialogImageUrlArray)
    },
    handleChange (file, fileList) {
      let types = ['image/png', 'image/jpeg', 'image/jpg']
      if (types.indexOf(file.raw.type) === -1) {
        this.$message.error('上传头像图片只能是 .png .jpeg .jpg 格式!')
        this.$refs.upload.clearFiles()
        return
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadimage(file).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传图片', type: 'success' })
        file.filename = res.data.filename
        this.dialogImageUrlArray.push(file)
      }).catch(() => {
        this.$message.closeAll()
        this.$refs.upload.uploadFiles = this.dialogImageUrlArray
        this.$message({ message: '上传图片失败', type: 'error' })
      })
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let pictures = ''
          for (let i = 0; i < this.dialogImageUrlArray.length; i++) {
            pictures = pictures === '' ? this.dialogImageUrlArray[i].filename : (pictures + ',' + this.dialogImageUrlArray[i].filename)
          }
          let sampleno = ''
          for (let i = 0; i < this.dynamicTags.length; i++) {
            sampleno = sampleno === '' ? this.dynamicTags[i] : (sampleno + ',' + this.dynamicTags[i])
          }
          if (this.addEditObj.isAdd) {
            let data = {
              'sampleday': this.addEditForm.sampleday,
              'operator': this.addEditForm.operator,
              'desc': this.addEditForm.desc,
              'pictures': pictures,
              'sampleno': sampleno,
              'vendor': this.addEditForm.vendor,
              'restaurantid': this.addEditForm.restaurantid,
              'eid': this.addEditForm.eid
            }
            addfoodsample(data).then(res => {
              this.$notify({title: '成功', message: '成功新增食物留样', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            let data = {
              id: this.addEditForm.id,
              'sampleday': this.addEditForm.sampleday,
              'operator': this.addEditForm.operator,
              'desc': this.addEditForm.desc,
              'pictures': pictures,
              'sampleno': sampleno,
              'vendor': this.addEditForm.vendor,
              'restaurantid': this.addEditForm.restaurantid,
              'eid': this.addEditForm.eid
            }
            updatefoodsample(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑食物留样', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditSample.vue